import React from 'react';
import { Loader2, HelpCircle } from 'lucide-react';
import { OptionKey } from '../data/types';

interface QuizSaveConfirmModalProps {
  isOpen: boolean;
  currentPos: number;
  targetPos: number;
  selectedKey?: OptionKey;
  isSaving?: boolean;
  onSaveAndJump: () => void;
  onDiscardAndJump: () => void;
  onClose: () => void;
}

export const QuizSaveConfirmModal: React.FC<QuizSaveConfirmModalProps> = ({
  isOpen,
  currentPos,
  targetPos,
  selectedKey,
  isSaving = false,
  onSaveAndJump,
  onDiscardAndJump,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fc-modal-overlay" onClick={isSaving ? undefined : onClose}>
      <div className="fc-modal-box" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '50%',
              background: '#EFF6FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#3B82F6',
              flexShrink: 0,
            }}
          >
            <HelpCircle size={22} />
          </div>
          <h3 className="fc-modal-title">Lưu câu trả lời?</h3>
        </div>

        <p className="fc-modal-desc">
          Bạn đã chọn đáp án{selectedKey ? <b> {selectedKey}</b> : ''} cho <b>Câu {currentPos}</b>. Bạn có muốn lưu lại đáp án này trước khi chuyển sang <b>Câu {targetPos}</b> không?
        </p>

        <div className="fc-modal-footer fc-save-confirm-footer" style={{ gap: '8px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="fc-modal-btn cancel"
            onClick={onClose}
            disabled={isSaving}
          >
            Ở lại câu này
          </button>

          <button
            type="button"
            className="fc-modal-btn"
            style={{
              border: '1px solid #CBD5E1',
              background: '#F8FAFC',
              color: '#475569',
              padding: '10px 16px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: isSaving ? 'default' : 'pointer',
              transition: 'all 0.15s ease',
            }}
            onClick={onDiscardAndJump}
            disabled={isSaving}
          >
            Không lưu
          </button>

          <button
            type="button"
            className="fc-modal-btn confirm"
            onClick={onSaveAndJump}
            disabled={isSaving}
          >
            {isSaving ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                <Loader2 className="fc-spinner-rotate" size={14} />
                <span>Đang lưu...</span>
              </span>
            ) : (
              'Lưu đáp án'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
